import * as React from 'react'

const Badge = ({ children, variant = 'primary', ...props }) => {
  return (
    <div
      sx={{
        display: 'inline-block',
        variant: `elements.badge.variants.${variant}`,
      }}
      {...props}
    >
      {children}
    </div>
  )
}

export default Badge
